export const USER_INFO = 'USER_INFO'
export const USER_CONDITION = 'USER_CONDITION'
export const USER_PRICING = 'USER_PRICING'
export const LOGOUT = 'LOGOUT'
export const SET_TOKEN = 'SET_TOKEN'
export const SHOW_TOAST_MESSAGE = 'SHOW_TOAST_MESSAGE'
export const SHOW_NOTI_LIST = 'SHOW_NOTI_LIST'
export const LOAD_CUSTOMER = 'LOAD_CUSTOMER'
export const SAVE_CUSTOMER = 'SAVE_CUSTOMER'
export const SET_REPORT_DATA = 'SET_REPORT_DATA'
export const SET_NOTICE_LIST = 'SET_NOTICE_LIST'
export const SET_MENU_LIST = 'SET_MENU_LIST'
export const GET_RECENT_INPUT_PRICE = 'GET_RECENT_INPUT_PRICE'
export const SET_RECENT_INPUT_PRICE = 'SET_RECENT_INPUT_PRICE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js